import {ErrorCodes, SimStationErrorDto} from "@models";
import {HttpErrorResponse} from "@angular/common/http";

export class ApiError {
	public readonly innerError: HttpErrorResponse;
	public readonly simError: SimStationErrorDto | null = null;

	public wasLogged = false;

	public hasSimError(): this is ApiError & {simError: SimStationErrorDto} {
		return !!this.simError;
	}

	public constructor(error: HttpErrorResponse) {
		this.innerError = error;
		this.simError = this.getSimError(error);
	}

	public getSimError(error: HttpErrorResponse) {
		const serverError = error?.error?.[0] as SimStationErrorDto;
		if (serverError?.errorCode in ErrorCodes) {
			return serverError;
		}
		return null;
	}
}
